import React from "react";
import { getDataWithQueryString } from "../../../api/componentAPIs";
import appConstant from "../../../appConstants";
import "./style.scss";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import styles from "./MapPopupStyles.js";
import Tooltip from '@material-ui/core/Tooltip';
import {minutesToTime} from '@dataGrid/gridUtilities';

class RoutePopupInfo extends React.Component {
  constructor(props) {
    super(props);
    this.routeId= this.props.data.routeId;
  }

  componentDidUpdate(prevProps){
    if (this.props.data !== prevProps.data) {
      this.routeId= this.props.data.routeId;
    }
  }
  // Code is not being called
  // endRouteAtTerminal = () => {
  //   this.endRouteAtLastStopOrTerminal({
  //     endAtLastStop: false,
  //     isDispatchView: this.props.isDispatchView
  //   });
  // }

  // endRouteAtLastStop = () => {
  //   this.endRouteAtLastStopOrTerminal({
  //     endAtLastStop: true,
  //     isDispatchView: this.props.isDispatchView
  //   });
  // };

  // endRouteAtLastStopOrTerminal = ({ endAtLastStop, isDispatchView }) => {
  //   // TODO: When we have API ready for EndRouteAtTerminal in dispatch view then we need to update the API name here
  //   const queryString =`scenarioId=${this.props.scenarioID}&routeId=${this.routeId}&endRouteAtLastStop=${endAtLastStop ? 1 :0 }`
  //   const routeUpdateAPI = isDispatchView
  //     ? "SetRouteTermination"
  //     : "SetRouteTermination";
  //   getDataWithQueryString(routeUpdateAPI, queryString).then(
  //     response => {
  //       if (response === undefined) {
  //         alert("Unable to update end of Route");
  //       } else if (response.length === 0) {
  //         alert("Changes Saved");
  //         // Events.emit("reRenderComponents");
  //       }
  //     },
  //     error => {
  //       alert(`Unable to update end of Route ${error.error}`);
  //     }
  //   );
  // }

  onToasterLoad = e => {
    this.toastr = e;
  };

  render() {
    const infoData = this.props.data || {};
    const lockState = infoData.isLocked
      ? appConstant.LockStates.find(
          lockState => lockState.value === infoData.isLocked
        )
      : null;
      const { classes, theme } = this.props;
      return(
        <Paper className={`${classes.routeStop} popupBGColor`}>
          <Table className={classes.table} padding="none">
            <TableHead className={classes.tableHead}>
              <TableRow className={classes.headHeight}>
                <TableCell colSpan={2} className={classes.tableHeadCell}>
                  <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={<div>Route Name : {infoData.routeName}</div>} placement="bottom-start">
                    <div className={classes.routeNameInfo}>{infoData.routeName}</div>
                  </Tooltip>
                  <Tooltip classes={{popper: "popper", tooltip:`tooltip-${theme}`}} title={<div>Start Time : {infoData.startTime}</div>}>
                    <div className={classes.startTime}>Start Time : {infoData.startTime}</div>
                    </Tooltip>
                    {/* {lockState ? <span className={lockState.icon}> </span> : null } */}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} ${classes.firstTableCell} tableCellName`}>Miles</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.firstTableCell} ${classes.popupDataStyle} tableCellValue`}>
                  {infoData.totalMiles} mi.
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} tableCellName`}>Time</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}>
                  {minutesToTime({value:infoData.totalTime})}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} tableCellName`}>Stops</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}>
                  {infoData.deliveryStopsCount}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} tableCellName`}>Missed Apts</TableCell>
                <TableCell className={`${classes.dataCell} ${classes.popupDataStyle} tableCellValue`}>
                  {infoData.numServiceViolations}
                </TableCell>
              </TableRow>
              <TableRow className={classes.tableRowRoot}>
                <TableCell className={`${classes.labelCell} ${classes.lastTableCell} tableCellName`}>
                  <div className={classes.dualCellLeft}>
                    Weight
                  </div>
                  <div className={classes.dualCellRight}>
                      PSE
                  </div>
                </TableCell>
                <TableCell className={` ${classes.dataCell} ${classes.popupDataStyle} ${classes.lastTableCell} tableCellValue`}>
                  <div className={classes.dualCellLeft}>
                    {infoData.totalWeight} lbs
                  </div>
                  <div className={classes.dualCellRight}>
                    {infoData.totalPse}
                  </div>
                </TableCell>
              </TableRow>
              {/* <TableRow className={classes.tableRowRoot} style={{ visibility:"hidden"}}>
                <TableCell className={classes.tableButtonCell}>
                  <Button
                  className={classes.popupButton}
                  variant="outlined"
                  color="inherit"
                  size="small"
                  disabled={infoData.isRouteTerminatedAtTerminal}
                  onClick={this.endRouteAtTerminal}>
                    End Route at Terminal
                  </Button>
                </TableCell>
                <TableCell className={`${classes.tableButtonCell} ${classes.tableButtonRight}`}>
                  <Button
                  className={classes.popupButton}
                  variant="outlined"
                  color="inherit"
                  size="small"
                  //disabled={!infoData.isRouteTerminatedAtTerminal}
                  onClick={this.endRouteAtLastStop}>
                    End Route at Last Stop
                  </Button>
                </TableCell>
              </TableRow> */}
            </TableBody>
          </Table>
        </Paper>
      );
  }
}

export default withStyles(styles)(RoutePopupInfo);
